module.exports = __webpack_public_path__ + "onboarding-steps.c00ee331a6ae184027c9acbdc1c562c7.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/projects/empty/onboarding-steps.svg
// module id = 1875093278595992
// module chunks = 1